import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { InvoiceCycleModel } from '../invoiceCycle/model/invoiceCycle'
import {
  AnnulmentCycleExecutionModel,
  AnnulmentCyclesListModel,
  ReinvoiceCycleExecutionModel,
  ReinvoiceCyclesListModel
} from './model/annulmentCycleStatus'
import {
  cfExecutionModel,
  cfExecutionPatchRequestModel,
  cfExecutionRequestModel,
  CloseExecutionCycleRequestModel,
  GlobalInvoiceCycleObjectionsTableModel,
  InvoiceCycleCountResponseModel,
  InvoiceCycleProcessingModel,
  InvoiceCycleWithLastExecutionModel
} from './model/cfExecutionModel'
import {
  CreateInvoiceCycleRequest,
  UpdateInvoiceCycleRequest
} from './model/createInvoiceCycleRequest'
import { InvoiceCycleCompatibilities } from './model/invoiceCycleCompatibilities'

export const apiGetActiveInvoiceCyclesExecutions = async (): Promise<cfExecutionModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/GetActiveInvoiceCyclesExecutions`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostInvoiceCyclesExecution = async (
  request: cfExecutionRequestModel
): Promise<cfExecutionModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/InvoiceCyclesExecutions`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiGetInvoiceCycleProcessing = async (
  executionCycleId: number
): Promise<InvoiceCycleProcessingModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/Processing(${executionCycleId})`
  ).then(response => {
    return response.data
  })
}

export const apiGetGlobalInvoiceCycleObjections = async (
  executionCycleId: number
): Promise<GlobalInvoiceCycleObjectionsTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/GlobalObjections(${executionCycleId})`
  ).then(response => {
    return response.data
  })
}

export const apiPatchInvoiceCyclesExecution = async (
  executionCycleId: number,
  request: cfExecutionPatchRequestModel
): Promise<cfExecutionModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/${executionCycleId}`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetTotalInvoiceCycles = async (): Promise<InvoiceCycleModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/GetTotalInvoiceCycles`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetAvailableInvoiceCycles = async (): Promise<InvoiceCycleModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/GetAvailableInvoiceCycles`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetInvoiceCyclesCount = async (): Promise<InvoiceCycleCountResponseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/GetInvoiceCyclesCount`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetInvoiceCycleExecutionByID = async (id: number): Promise<cfExecutionModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/InvoiceCyclesExecutions/${id}`).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiGetFinishedExecutionsByInvoiceCycleId = async (
  id: number
): Promise<cfExecutionModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/invoiceCycle/${id}/GetFinishedInvoiceCyclesExecutions`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetInvoiceCycleByID = async (id: number): Promise<InvoiceCycleModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/InvoiceCycle/${id}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiCreateInvoiceCycle = async (
  request: CreateInvoiceCycleRequest
): Promise<InvoiceCycleModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/CreateInvoiceCycle`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetInvoiceCycleCompatibilities = async (): Promise<
  InvoiceCycleCompatibilities[]
> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/GetInvoiceCycleCompatibilities`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiEditInvoiceCycle = async (
  request: UpdateInvoiceCycleRequest
): Promise<InvoiceCycleModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/UpdateInvoiceCycle`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiDeleteInvoiceCycle = async (invoiceCycleId: number): Promise<void> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/DeleteInvoiceCycle/${invoiceCycleId}`
  ).then(response => {
    return response.data
  })
}

export const apiCloseExecutionCycle = async (
  request: CloseExecutionCycleRequestModel
): Promise<void> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/CloseExecutionCycle`,
    request
  ).then(response => {
    return response.data
  })
}

export const apiGetAnnulmentCycleStatus = async (
  subjectType: number
): Promise<AnnulmentCyclesListModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/AnnulmentCycleStatus?subjectType=${subjectType}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return { invoiceCycleList: [] }
    }
  })
}

export const apiGetAnnulmentCycleExecution = async (
  invoiceCycleId: number
): Promise<AnnulmentCycleExecutionModel | null> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/AnnulmentCycleExecution(${invoiceCycleId})`
  ).then(response => {
    return response.data ?? null
  })
}

export const apiGetInvoiceCyclesExecutions = async (
  subjectType?: number,
  activesOnly?: boolean,
  commodity?: number
): Promise<InvoiceCycleWithLastExecutionModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/InvoiceCyclesExecutions`, {
    params: { subjectType, activesOnly, commodity }
  }).then(response => {
    return response.data ?? []
  })
}

export const apiGetReinvoiceCycleStatus = async (
  subjectType: number
): Promise<ReinvoiceCyclesListModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/ReinvoiceCycleStatus?subjectType=${subjectType}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return { invoiceCycleList: [] }
    }
  })
}

export const apiGetReinvoiceCycleExecution = async (
  invoiceCycleId: number
): Promise<ReinvoiceCycleExecutionModel | null> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/InvoiceCyclesExecutions/ReinvoiceCycleExecution(${invoiceCycleId})`
  ).then(response => {
    return response.data ?? null
  })
}
